"use strict";
/**
 * @module Shapes
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var planimetry_1 = require("../planimetry");
var DefaultMouseEvent_1 = require("../handler/DefaultMouseEvent");
var Shape = /** @class */ (function (_super) {
    __extends(Shape, _super);
    /**
     * 构造函数
     */
    function Shape() {
        var _this = _super.call(this) || this;
        /**
         * 表示当前是否进入了该shape
         */
        _this.isEnter = false;
        /**
         * 表示当前是否离开了该shape
         */
        _this.isLeave = false;
        /**
         * 当前图像是否可见
         */
        _this.visable = true;
        _this.engine = null;
        _this.drawState = null;
        _this.selected = false;
        _this.transformMatrix = planimetry_1.createTransformMatrix();
        _this.renderAfterState = function (ctx) {
            var _a = __read(_this.transformMatrix, 6), a = _a[0], c = _a[1], e = _a[2], b = _a[3], d = _a[4], f = _a[5];
            ctx.setTransform(a, b, c, d, e, f);
            if (_this.drawState) {
                ctx.save();
                _this.drawState.direction && (ctx.direction = _this.drawState.direction);
                _this.drawState.font && (ctx.font = _this.drawState.font);
                _this.drawState.textAlign && (ctx.textAlign = _this.drawState.textAlign);
                _this.drawState.textBaseline && (ctx.textBaseline = _this.drawState.textBaseline);
                _this.drawState.fillStyle && (ctx.fillStyle = _this.drawState.fillStyle);
                _this.drawState.strokeStyle && (ctx.strokeStyle = _this.drawState.strokeStyle);
                _this.drawState.filter && (ctx.filter = _this.drawState.filter);
                _this.drawState.globalAlpha && (ctx.globalAlpha = _this.drawState.globalAlpha);
                _this.drawState.globalCompositeOperation && (ctx.globalCompositeOperation = _this.drawState.globalCompositeOperation);
                _this.drawState.imageSmoothingEnabled && (ctx.imageSmoothingEnabled = _this.drawState.imageSmoothingEnabled);
                _this.drawState.imageSmoothingQuality && (ctx.imageSmoothingQuality = _this.drawState.imageSmoothingQuality);
                _this.drawState.lineCap && (ctx.lineCap = _this.drawState.lineCap);
                _this.drawState.lineDashOffset && (ctx.lineDashOffset = _this.drawState.lineDashOffset);
                _this.drawState.lineJoin && (ctx.lineJoin = _this.drawState.lineJoin);
                _this.drawState.lineWidth && (ctx.lineWidth = _this.drawState.lineWidth);
                _this.drawState.miterLimit && (ctx.miterLimit = _this.drawState.miterLimit);
                _this.drawState.shadowBlur && (ctx.shadowBlur = _this.drawState.shadowBlur);
                _this.drawState.shadowColor && (ctx.shadowColor = _this.drawState.shadowColor);
                _this.drawState.shadowOffsetX && (ctx.shadowOffsetX = _this.drawState.shadowOffsetX);
                _this.drawState.shadowOffsetY && (ctx.shadowOffsetY = _this.drawState.shadowOffsetY);
                _this.render(ctx);
                ctx.restore();
            }
            else {
                _this.render(ctx);
            }
        };
        /**
         * 渲染函数
         */
        _this.render = function () { };
        _this.value = [];
        _this.zindex = Shape.autoIndex++;
        return _this;
    }
    Shape.prototype.isSelected = function () {
        return this.selected;
    };
    Shape.prototype.select = function () {
        this.selected = true;
    };
    Shape.prototype.unSelect = function () {
        this.selected = false;
    };
    Shape.prototype.setEngine = function (engine) {
        this.engine = engine;
    };
    Shape.prototype.remove = function () {
        if (this.engine) {
            this.engine.remove(this);
        }
    };
    Shape.prototype.inRegion = function (p) {
        var isIn = planimetry_1.isInPolygon(this.tranValueOf(), p);
        return isIn;
    };
    Shape.prototype.inRegionAndSetEnterState = function (p) {
        var isIn = this.inRegion(p);
        if (isIn) {
            if (!this.isEnter) {
                this.isEnter = true;
                this.isLeave = false;
            }
        }
        else {
            if (this.isEnter) {
                this.isEnter = false;
                this.isLeave = true;
            }
        }
        return isIn;
    };
    ;
    /**
     * 向上移动
     * @param n 像素量
     */
    Shape.prototype.moveUp = function (n) {
        this.transformMatrix = planimetry_1.translate(this.transformMatrix, 0, -n);
        this.updateValue();
    };
    /**
     * 向下移动
     * @param n 像素量
     */
    Shape.prototype.moveDown = function (n) {
        this.transformMatrix = planimetry_1.translate(this.transformMatrix, 0, n);
        this.updateValue();
    };
    /**
     * 向左移动
     * @param n 像素量
     */
    Shape.prototype.moveLeft = function (n) {
        this.transformMatrix = planimetry_1.translate(this.transformMatrix, -n, 0);
        this.updateValue();
    };
    /**
     * 向右移动
     * @param n 像素量
     */
    Shape.prototype.moveRight = function (n) {
        this.transformMatrix = planimetry_1.translate(this.transformMatrix, n, 0);
        this.updateValue();
    };
    /**
     * 伸缩
     * @param x 横轴伸缩倍数
     * @param y 纵轴伸缩倍数
     */
    Shape.prototype.scale = function (x, y) {
        if (x === void 0) { x = 0; }
        if (y === void 0) { y = 0; }
        this.transformMatrix = planimetry_1.scale(this.transformMatrix, x, y);
        // this.updateValue();
    };
    /**
     * 设置原始值
     * @param value 控制点
     */
    Shape.prototype.setValue = function (value) {
        this.value = value;
    };
    /**
     * 获取原始值
     */
    Shape.prototype.valueOf = function () {
        return planimetry_1.copyPath(this.value);
    };
    ;
    /**
     * 返回转换后的原始值
     */
    Shape.prototype.tranValueOf = function () {
        return planimetry_1.transformPath(this.transformMatrix, planimetry_1.copyPath(this.value));
    };
    /**
     * 更新控制点并恢复transformMatrix
     */
    Shape.prototype.updateValue = function () {
        this.setValue(this.tranValueOf());
        this.transformMatrix = planimetry_1.createTransformMatrix();
    };
    /**
     * 自增id
     */
    Shape.autoIndex = 0;
    return Shape;
}(DefaultMouseEvent_1.DefaultMouseEvent));
exports.Shape = Shape;
//# sourceMappingURL=Shape.js.map